import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image12 from "../../../../assets/images/blog49/image12.png";
import image5 from "../../../../assets/images/blog49/image5.png";
import image36 from "../../../../assets/images/blog49/image36.png";
import image9 from "../../../../assets/images/blog49/image9.png";
import image35 from "../../../../assets/images/blog49/image35.png";
import image3 from "../../../../assets/images/blog49/image3.png";
import image4 from "../../../../assets/images/blog49/image4.png";
import image21 from "../../../../assets/images/blog49/image21.png";
import image22 from "../../../../assets/images/blog49/image22.png";
import image18 from "../../../../assets/images/blog49/image18.jpeg";
import image19 from "../../../../assets/images/blog49/image19.png";
import image17 from "../../../../assets/images/blog49/image17.png";
import image13 from "../../../../assets/images/blog49/image13.png";
import image27 from "../../../../assets/images/blog49/image27.png";
import image8 from "../../../../assets/images/blog49/image8.png";
import image39 from "../../../../assets/images/blog49/image39.jpeg";
import image46 from "../../../../assets/images/blog49/image46.png";
import image51 from "../../../../assets/images/blog49/image51.jpeg";
import image52 from "../../../../assets/images/blog49/image52.png";
import image15 from "../../../../assets/images/blog49/image15.png";
import image59 from "../../../../assets/images/blog49/image59.jpeg";

const Blog49 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – December 29th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedBoldText ">Physical Stress Surfaces, Liquidity Carries the Tape, and Markets Drift Into Year-End</p>
        <p>
          Markets moved through the final full trading week of the year with little urgency but plenty of signals. Liquidity remained thin, conviction was limited, and yet price action held together
          far better than sceptics expected. This was not driven by fresh optimism or new macro clarity, but by structure, positioning, and the continued absence of forced selling.
        </p>
        <p>
          Beneath the surface, however, pressure is quietly building. Physical markets—particularly in metals—are flashing stress signals that paper systems cannot indefinitely smooth over. Stress in
          physical markets suggests increasing tension between paper pricing and real-world settlement as the year closes.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Structure Holds as Flows Do the Heavy Lifting</p>
              <p>
                Equities continue to grind higher into year-end, supported by a structural rather than an enthusiastic backdrop. The rally from the October 2022 lows remains intact, and this cycle has
                been driven by earnings growth rather than indiscriminate multiple expansion.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt="cyclical bull market Oct22"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                That distinction matters. As long as earnings continue to justify prices, equity indices will continue to attract flows. Breadth has improved meaningfully, with a healthy proportion of
                stocks trading above short- and medium-term moving averages.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image36}
                    alt="US sector resilience"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image36)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                However, longer-term breadth remains less convincing. The percentage of stocks above the 100- and 150-day averages has not yet confirmed a decisive breakout, reinforcing the idea that
                this is persistence rather than acceleration.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="sector saturation"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Rotation continues to play an important role. The Dow's leading relative performance suggests ongoing interest in health care, financials, and energy rather than a narrow, growth-only
                rally.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image35}
                    alt="record 2025 comeback"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image35)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                <span className="highlightedText">Play momentum, not laggards.</span> This is not the phase of the cycle where mean-reversion trades are being rewarded.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Liquidity Is Plentiful, Growth Is Not</p>

              <p>
                Macro conditions remain defined by contradiction. Liquidity is abundant—globally and persistently—but it is not translating cleanly into productive growth. Money supply continues to
                expand far faster than GDP, implying dilution rather than expansion.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="US M2 heights"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Crucially, this does not automatically mean financial conditions are expansionary. Much of this liquidity appears to be hoarded, recycled, or used defensively rather than deployed into
                growth-enhancing investment.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt="global liquidity but is it being hoarded?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Governments themselves are losing purchasing power, reinforcing why markets are bidding up scarce and real assets. Rates sit close to neutral, but history suggests neutrality rarely
                lasts long. When long-dated yields sit above nominal growth—particularly with elevated debt levels—stress eventually shows up in servicing costs and policy pressure.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt="debt dynamics"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt="US Monetary Policy stance 2006+"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>Looking ahead, the debate is less about rate cuts already delivered and more about whether yields can be controlled without reigniting inflation. That tension will define 2026.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                From a technical standpoint, the structure remains intact. Pullbacks have been shallow, consolidation has occurred near highs, and broader trends have not broken. However, momentum has
                slowed, and price action feels more sensitive to disappointment.
              </p>
              <p>Sentiment captures that unease. Indicators sit close to neutral—neither pessimistic enough to trigger capitulation nor complacent enough to justify aggressive risk-taking.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt="alpine sentiment neutral"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Groupthink is becoming more evident. Expectations cluster around “smaller upside, but still upside,” a condition that often masks the potential for sharper swings in both directions.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt="SPX forecasts back to group think"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Volatility remains suppressed, which historically supports equity drift, but timing matters. Low volatility into year-end often delays adjustment rather than eliminating it.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt="VIX boost ahead"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Positioning and sentiment conditions suggest asymmetric outcomes around disappointment rather than broad upside expansion.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Liquidity Stress, Metals Signal, and Growth Reality</p>
              <p>Markets started the week quietly but firmed into the close as structural flows dominated thin liquidity. With limited headline data, underlying stresses became more visible.</p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro:</span>
                    <br></br>US GDP surprised to the upside, but this strength largely reflects backwards-looking data. Shutdown distortions are expected to weigh on Q4 estimates, with forward growth
                    already softening. Housing data continues to show how aggregates mask sharp divergences beneath the surface.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image12}
                        alt="Atlanta GDP Q3 peak"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image12)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image13}
                        alt="Atlanta GDP into Q4 pullback"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image13)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>Physical demand from China remains a central theme, particularly in commodities. Silver demand continues to bypass Western paper markets, reinforcing the divergence
                    between Shanghai pricing and COMEX structures.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image27}
                        alt="China running softly"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image27)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br> Earnings remain the backbone of the equity rally. The post-October 2022 advance has been earnings-led, and until that changes, equities are likely to retain structural
                    support.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image8}
                      alt=" a bubble with earnings?"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image8)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities:</span>
                    <br></br>Gold continues to act like a zero-coupon bond in a world where long-dated fixed income no longer offers safety. Silver stood out as physical stress intensified, with
                    backwardation and delivery premiums signalling distrust of paper settlement.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image39}
                      alt="gold leads commods?"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image39)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image46}
                      alt="silver arbitrage breakdown warning"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image46)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br>Crypto volatility increasingly resembles a positioning shakeout rather than a trend reversal. Consolidation has tested conviction, but belief in the asset class is being
                    challenged rather than abandoned.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image51}
                        alt=" BTC flag bear"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image51)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image52}
                        alt="BTC bottom?"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image52)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Energy remains capped by sentiment, but growing geopolitical optionality is becoming harder to ignore. With positioning negative, it would not take much to trigger a
                    reflexive move higher.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image15}
                        alt="oil fragile recovery"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image15)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Holiday Liquidity and Key Macro Signals</p>
              <p>
                The final week of the year remains dominated by holiday conditions and thin liquidity. With US equity markets largely quiet and many global venues closed or operating on reduced hours,
                price action is likely to be driven more by flows and funding dynamics than by headline data. Still, a handful of macro releases and central-bank communications could matter,
                particularly where they intersect with liquidity, housing, and inflation expectations.
              </p>
              <p className="highlightedText">Monday, December 29</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.: </span> Pending Home Sales (MoM, Nov)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.: </span> Dallas Fed Manufacturing Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Japan:</span> BoJ Summary of Opinions
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, December 30</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> Core CPI (Dec)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Spain:</span> CPI (Dec), Retail Sales (Nov)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> House Price Index (Oct)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> FOMC Meeting Minutes
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, December 31</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Manufacturing & Non-Manufacturing PMI (Dec)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> Initial & Continuing Jobless Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> Chicago PMI (Dec)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> Multiple market holidays and early closes
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, January 1</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> New Year’s Day — major markets closed
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, January 2</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> S&P Global Manufacturing PMI (Dec)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> Final Manufacturing PMIs
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.K.: </span> Nationwide House Price Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> Fed Balance Sheet & Reserve Balances
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image59}
                      alt="EW 291225"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image59)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: A Grind Higher, With Cracks Beneath</p>
              <p>Markets are ending the year supported, but uneasy. Liquidity and structure are carrying risk assets, yet trust in paper systems is being quietly tested.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Structure remains constructive, and earnings continue to do the heavy lifting. Upside persists, but it is increasingly selective rather than broad-based.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Gold continues to benefit from falling trust in long-dated bonds. Silver’s move is more structural, driven by
                    physical scarcity and delivery stress rather than speculative froth.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Belief is being tested, not broken. Consolidation may persist, but volatility is likely before clarity emerges.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> Liquidity is abundant, but growth is lagging. Debt dynamics, yield control, and fiscal reality—not policy soundbites—will
                    shape conditions in 2026.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">
                This still feels like a grind higher—until it doesn’t. Flows decide direction, but crowded trades unwind quietly before they unwind violently. Participate, but stay nimble.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt="alpine sentiment neutral"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt="US Monetary Policy stance 2006+"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt="VIX boost ahead"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1jSnH8KxlHNCWYLzRu0e0MzekmHx9ZpyvFIJuChnbs3M/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog49;
